import React, { useMemo } from "react";
import { FieldArray, useFormikContext } from "formik";
import Emoji from "./message/Emoji";
import MsgButtons from "./message/Buttons";
import QuickResponse from "./message/QuickyResponse.js";
import _Input from "../../generic/_Input.js";
import _Select from "../../generic/_Select.js";
import OptionLabelsSelector from "../OptionLabelsSelector.js";
import { HEIGHTS, ORIENTATIONS } from "../../../utils/globals.js";
import _Button from "../../generic/_Button.js";
import Icon from "../../Icon.js";
import MediaActions from "./message/media/MediaActions.js";
import ImageActions from "./message/ImageActions.js";
import { useCountChars } from "../hooks/useCountChars.js";
import PropTypes from "prop-types";
import { useReplaceMessage } from "../../../hooks/useReplaceMessage.js";
import SendTestRCS from "./test/SendTestRCS.js";
import Template from "../Template/Template.js";
import ShortUrls from "../ShortCodes/ShortUrls.js";
import MessageTemplates from "../Template/MessageTemplates.js";
const CardCharacterCounter = ({ message }) => {
  const { count, maxCharacters } = useCountChars(message);

  return (
    <div className="flex items-center justify-end mb-2">
      <span className="text-[12px] font-semibold px-2 text-yellow-800">
        {count}/{maxCharacters} Caracteres
      </span>
    </div>
  );
};
const MessageRcs = ({ isTemplate = false, isAdmin = false }) => {
  const { values, setFieldValue, handleChange, handleBlur, errors } =
    useFormikContext();

  const { count, maxCharacters, type } = useCountChars(values.rcsmessage);
  const replaceMessage = useReplaceMessage(values.fieldsInfo);

  const renderTextArea = () => {
    switch (values.step) {
      case 1:
        return (
          <div className="py-3">
            <div className="border rounded-lg px-4 py-2 mb-2">
              {!isTemplate && (
                <div className="flex justify-end gap-2 mb-2 text-sm">
                  <Template
                    onChange={(value) =>
                      setFieldValue(
                        "rcsmessage",
                        `${values.rcsmessage} {${value}}`,
                      )
                    }
                    value={values.rcsmessage}
                  />
                  <ShortUrls
                    onChange={(value) =>
                      setFieldValue(
                        "rcsmessage",
                        `${values.rcsmessage} ${value}`,
                      )
                    }
                  />
                </div>
              )}
              <_Input
                title="Mensaje"
                required
                name="rcsmessage"
                id="rcsmessage"
                alias="textarea"
                rows={5}
                placeholder="Escriba su mensaje"
                value={values.rcsmessage}
                onChange={handleChange}
                onBlur={handleBlur}
                errors={errors && errors.rcsmessage}
                isError={errors && errors.rcsmessage ? true : false}
              />
              <CardCharacterCounter message={values.rcsmessage} />
            </div>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
              <QuickResponse />
              <MediaActions />
              <Emoji
                onChange={(emoji) => {
                  setFieldValue("emoji", {
                    emoji: emoji.emoji,
                    unified: emoji.unified,
                  });
                  setFieldValue("rcsmessage", values.rcsmessage + emoji.emoji);
                }}
              />
            </div>
          </div>
        );

      case 2:
        return (
          <div className="py-3">
            <div className="border rounded-lg px-4 py-2 mb-2">
              {!isTemplate && (
                <div className="flex justify-end gap-2 mb-2 text-sm">
                  <Template
                    onChange={(value) =>
                      setFieldValue(
                        "title_rcs_message",
                        `${values.title_rcs_message} {${value}}`,
                      )
                    }
                    value={values.title_rcs_message}
                  />
                </div>
              )}
              <_Input
                required
                title="Título del Mensaje"
                type="text"
                name="title_rcs_message"
                id="title_rcs_message"
                value={values.title_rcs_message}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Escriba el titulo de su mensaje"
                errors={errors && errors.title_rcs_message}
                isError={errors && errors.title_rcs_message ? true : false}
              />
            </div>
            <div className="border rounded-lg px-4 py-2 mb-2">
              {!isTemplate && (
                <div className="flex justify-end gap-2 mb-2 text-sm">
                  <Template
                    onChange={(value) =>
                      setFieldValue(
                        "rcsmessage",
                        `${values.rcsmessage} {${value}}`,
                      )
                    }
                    value={values.rcsmessage}
                  />
                  <ShortUrls
                    onChange={(value) =>
                      setFieldValue(
                        "rcsmessage",
                        `${values.rcsmessage} ${value}`,
                      )
                    }
                  />
                </div>
              )}

              <_Input
                title="Mensaje"
                required
                name="rcsmessage"
                id="rcsmessage"
                alias="textarea"
                rows={5}
                placeholder="Escriba su mensaje"
                value={values.rcsmessage}
                onChange={handleChange}
                onBlur={handleBlur}
                errors={errors && errors.rcsmessage}
                isError={errors && errors.rcsmessage ? true : false}
              />
              <CardCharacterCounter message={values.rcsmessage} />
            </div>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
              <_Select
                name="height"
                value={values.height}
                onChange={handleChange}
                title="Resolución"
                options={HEIGHTS}
                errors={errors && errors.height ? errors.height : ""}
                isError={errors && errors.height ? true : false}
                required
              />
              <_Select
                name="cardOrientation"
                value={values.cardOrientation}
                onChange={handleChange}
                title="Orientación"
                options={ORIENTATIONS}
                errors={
                  errors && errors.cardOrientation ? errors.cardOrientation : ""
                }
                isError={errors && errors.cardOrientation ? true : false}
                required
              />
            </div>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
              <MsgButtons />
              <QuickResponse />
              <ImageActions />
              <Emoji
                onChange={(emoji) =>
                  setFieldValue(
                    "rcsmessage",
                    values.rcsmessage + `{{${emoji.unified.toUpperCase()}}}`,
                  )
                }
              />
            </div>
          </div>
        );

      case 3:
        return (
          <>
            <FieldArray name="carrousel">
              {({ push, remove }) => (
                <div className="space-y-4">
                  <div className="flex justify-end py-2 items-center">
                    <_Button
                      title="Agregar tarjeta"
                      icon="add"
                      style="primary"
                      onClick={() =>
                        push({
                          title: "",
                          description: "",
                          imageUrl: "",
                          height: "",
                          buttonActions: [],
                          buttonQuickReplies: [],
                        })
                      }
                    />
                  </div>

                  {values.carrousel?.length > 0
                    ? values.carrousel.map((card, index) => (
                        <div
                          key={index}
                          className="border rounded-lg p-3 relative bg-gray-50"
                        >
                          <div className="font-semibold text-xl text-gray-800 mb-1">
                            Card {index + 1}
                          </div>
                          <div className="absolute right-0 top-0">
                            <button
                              type="button"
                              className="rounded-full flex items-center border-none p-2 hover:bg-gray-400 hover:text-white all-transition duration-200"
                              onClick={() => remove(index)}
                            >
                              <Icon
                                icon="close"
                                className={"hover:text-white"}
                              />
                            </button>
                          </div>
                          <div className="p-3 border rounded-lg my-2">
                            {!isTemplate && (
                              <div className="flex justify-end gap-2 mb-2 text-sm">
                                <Template
                                  onChange={(value) =>
                                    setFieldValue(
                                      `carrousel[${index}].title`,
                                      `${card.title} {${value}}`,
                                    )
                                  }
                                  value={card.title}
                                />
                              </div>
                            )}

                            <_Input
                              title="Título"
                              name={`carrousel[${index}].title`}
                              id={`carrousel[${index}].title`}
                              value={card.title}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              errors={errors?.carrousel?.[index]?.title}
                              isError={!!errors?.carrousel?.[index]?.title}
                            />
                          </div>
                          <div className="p-3 border rounded-lg">
                            {!isTemplate && (
                              <div className="flex justify-end gap-2 mb-2 text-sm">
                                <Template
                                  onChange={(value) =>
                                    setFieldValue(
                                      `carrousel[${index}].description`,
                                      `${card.description} {${value}}`,
                                    )
                                  }
                                  value={card.description}
                                />
                                <ShortUrls
                                  onChange={(value) =>
                                    setFieldValue(
                                      `carrousel[${index}].description`,
                                      `${card.description} ${value}`,
                                    )
                                  }
                                />
                              </div>
                            )}

                            <_Input
                              title="Descripción"
                              alias="textarea"
                              rows={3}
                              name={`carrousel[${index}].description`}
                              id={`carrousel[${index}].description`}
                              value={card.description}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              errors={errors?.carrousel?.[index]?.description}
                              isError={
                                !!errors?.carrousel?.[index]?.description
                              }
                            />
                            <CardCharacterCounter message={card.description} />
                          </div>

                          <_Select
                            name={`carrousel[${index}].height`}
                            id={`carrousel[${index}].height`}
                            value={card.height}
                            onChange={handleChange}
                            title="Resolución"
                            options={HEIGHTS}
                            errors={errors?.carrousel?.[index]?.height}
                            isError={!!errors?.carrousel?.[index]?.height}
                          />
                          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
                            <MsgButtons carrousel={index} />
                            <QuickResponse carrousel={index} />
                            <ImageActions carrousel={index} />
                            <Emoji
                              onChange={(emoji) => {
                                setFieldValue(
                                  `carrousel.${index}.description`,
                                  values?.carrousel?.[index].description +
                                    `{{${emoji.unified.toUpperCase()}}}`,
                                );
                              }}
                            />
                          </div>
                        </div>
                      ))
                    : null}

                  {/* <Icon icon="info" />
                     <span className="text-sm text-yellow-700">
                     Agregue al menos una tarjeta
                     </span> */}
                </div>
              )}
            </FieldArray>
          </>
        );

      default:
        return null;
    }
  };

  const MESSAGE_TYPES = {
    SINGLE: "Single",
    BASIC: "Basic",
    RICH_CARD: "Rich Card",
    CAROUSEL: "Carousel",
  };
  const getMessageType = ({ step }) => {
    if (step === 3) return MESSAGE_TYPES.CAROUSEL;
    if (step === 2) return MESSAGE_TYPES.RICH_CARD;

    if (step === 1 && (values.imageUrl || values.buttonQuickReplies.length > 0))
      return MESSAGE_TYPES.SINGLE;
    if (step === 1) return MESSAGE_TYPES[type];
    return MESSAGE_TYPES.BASIC;
  };

  const messageType = useMemo(() => {
    return getMessageType({
      chars: count,
      limit: maxCharacters,
      step: values.step,
    });
  }, [
    count,
    maxCharacters,
    values.step,
    values.imageUrl,
    values.buttonQuickReplies,
  ]);
  return (
    <div className="bg-white !px-4 py-3 rounded-lg">
      <div className="flex justify-between mb-2">
        <div className="flex items-center justify-start gap-2">
          <div className="text-xl font-bold text-gray-600">Mensaje RCS</div>
          <span className="bg-blue-200 text-blue-700 px-2 py-1 text-xs font-semibold rounded-lg">
            {messageType}
          </span>
        </div>
        {!isTemplate && !isAdmin ? <MessageTemplates /> : null}
      </div>

      <OptionLabelsSelector
        onChange={(step) => setFieldValue("step", step)}
        value={values.step}
        options={[
          {
            label: "Simple",
            value: 1,
          },
          {
            label: "Avanzado",
            value: 2,
          },
          {
            label: "Carrousel",
            value: 3,
          },
        ]}
      />
      {renderTextArea()}
      <div className="flex flex-col w-full justify-between gap-2">
        <SendTestRCS messageWithTemplate={replaceMessage(values.rcsmessage)} />
      </div>
    </div>
  );
};

CardCharacterCounter.propTypes = {
  message: PropTypes.string,
};

MessageRcs.propTypes = {
  isTemplate: PropTypes.bool,
  isAdmin: PropTypes.bool,
};
export default MessageRcs;
